var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContextVariables = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.268 14C18.0378 15.3333 19.9623 15.3333 20.7321 14L26.7942 3.5C27.564 2.16667 26.6018 0.5 25.0622 0.5H12.9378C11.3982 0.5 10.436 2.16667 11.2058 3.5L17.268 14ZM12.9378 2.5L19 13L25.0622 2.5L12.9378 2.5Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19C0 17.8954 0.895431 17 2 17H12C13.1046 17 14 17.8954 14 19V29C14 30.1046 13.1046 31 12 31H2C0.89543 31 0 30.1046 0 29V19ZM2 19H12V29H2L2 19Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 24C38 27.866 34.866 31 31 31C27.134 31 24 27.866 24 24C24 20.134 27.134 17 31 17C34.866 17 38 20.134 38 24ZM36 24C36 26.7614 33.7614 29 31 29C28.2386 29 26 26.7614 26 24C26 21.2386 28.2386 19 31 19C33.7614 19 36 21.2386 36 24Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9708 15.2302C28.7906 12.8652 27.7878 10.7302 26.248 9.11079L27.3488 7.38086C29.3763 9.34504 30.7129 12.0182 30.9589 15.0005C30.2755 15.0036 29.6101 15.0828 28.9708 15.2302Z",
    fill: "#071A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04108 15.0004C7.28711 12.0181 8.62371 9.34503 10.6512 7.38086L11.752 9.11079C10.2622 10.6776 9.27509 12.7271 9.04938 15.0004H7.04108Z",
    fill: "#071A24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1248 25.5025C21.1417 25.8257 20.0912 26.0004 19 26.0004C17.9548 26.0004 16.947 25.8401 16 25.5426V27.6224C16.9589 27.8692 17.9641 28.0004 19 28.0004C20.282 28.0004 21.517 27.7994 22.6753 27.4272C22.4237 26.8165 22.2373 26.1721 22.1248 25.5025Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContextVariables);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/context_variables.bf5622c539f7f4260464033a7085cdf3.svg";